import React from 'react';
import { Link } from 'react-router-dom';
import { Container } from '../../components/ui/Container';
export function TermsAndConditions() {
  return <>
      <section className="py-16 md:py-24" data-id="element-3940" data-mp="106p2fakmieeh">
        <Container data-id="element-3941" data-mp="1e4m0ycin0uvs">
          <div className="max-w-4xl mx-auto" data-id="element-3942" data-mp="1e32m8qcmqrw4">
            <h1 className="font-display text-4xl md:text-6xl text-ink-900 leading-tight" data-id="element-3943" data-mp="1959f9v3i5tus">
              Terms & Conditions
            </h1>
            <p className="mt-4 text-ink-500" data-id="element-3944" data-mp="lgq85iw6vn4a">
              <strong data-id="element-3945" data-mp="ldc4m7bsh7v9">Last updated:</strong> February 1, 2026
            </p>

            <div className="mt-10 space-y-8 text-ink-700 leading-relaxed" data-id="element-3946" data-mp="hfo3gmji6iux">
              <p data-id="element-3947" data-mp="v6jgmb11bm4b">
                These Terms and Conditions (the "Terms") govern your access to
                and use of the{' '}
                <strong data-id="element-3948" data-mp="qcoqaoqxc8w9">International Islamic Learning Hub (IILH)</strong>{' '}
                website, as well as your participation in any programs,
                services, and activities organized by us.
              </p>
              <p data-id="element-3949" data-mp="10h57wyybnnwk">
                By accessing this website, registering for an account, or
                engaging with our services, you expressly agree to be bound by
                these Terms.
              </p>
              <p data-id="element-3950" data-mp="1a6ezmdp974k5">
                If you do not agree with any part of these Terms, you must
                discontinue use of the website immediately.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3951" data-mp="hi9bdgyzqxfk">
                Use of the Website
              </h2>
              <p data-id="element-3952" data-mp="mgkoq1ohvq2j">
                The content provided on this website is intended solely for
                informational, educational, and community support purposes.
              </p>
              <p data-id="element-3953" data-mp="vik6iw7c2y6j">
                <strong data-id="element-3954" data-mp="vj3pmg8pzsm5">Lawful Use:</strong> Users agree to use this website in
                a respectful manner and in full compliance with all applicable
                laws and regulations.
              </p>
              <p data-id="element-3955" data-mp="26vmj7g6bb3lf">
                <strong data-id="element-3956" data-mp="26zafuo72064d">Prohibited Activities:</strong> Unauthorized use of this
                website, misuse of its content, or any behavior deemed harmful
                to the platform or its community is strictly prohibited. This
                includes, but is not limited to, distributing malware, data
                scraping, or harassment of other users.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3957" data-mp="buu8xkq4khhh">
                Programs and Services
              </h2>
              <p data-id="element-3958" data-mp="3g8ixr6dkj6ej">
                <strong data-id="element-3959" data-mp="3g925xvdf2gfd">Eligibility:</strong> Participation in specific
                educational programs or services may be subject to strict
                eligibility criteria and a review of your application.
              </p>
              <p data-id="element-3960" data-mp="3p7e72rbwswm2">
                <strong data-id="element-3961" data-mp="3p6umf2uvju4c">Right to Modify:</strong> The International Islamic
                Learning Hub reserves the right to modify, suspend, or
                discontinue any program or service at any time without prior
                notice.
              </p>
              <p data-id="element-3962" data-mp="1c1ft6qvfizk0">
                <strong data-id="element-3963" data-mp="1c0y0g47z73gu">No Guarantee of Results:</strong> While we strive for
                excellence, we provide no guarantee of specific educational
                outcomes or personal results from our support services.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3964" data-mp="180e3b0nejzup">
                Payments and Financial Terms
              </h2>
              <p data-id="element-3965" data-mp="1vqq7c0fj1cg0">
                <strong data-id="element-3966" data-mp="1vo40k30gn0yu">General:</strong> All donations, membership fees, and
                program costs are subject to the specific terms disclosed to you
                at the point of payment.
              </p>
              <p data-id="element-3967" data-mp="1qr595s86l84c">
                <strong data-id="element-3968" data-mp="1qqm2j7nze65m">Donations:</strong> All donations are voluntary and are
                strictly non-refundable.
              </p>
              <p data-id="element-3969" data-mp="ac3x09gl2pxs">
                <strong data-id="element-3970" data-mp="abkk575sirqm">Refunds:</strong> Memberships and paid educational
                programs are governed specifically by our{' '}
                <Link to="/en/legal/refund-policy" className="text-forest-700 underline hover:text-forest-800" data-id="element-3971" data-mp="uldcqnd19l11">
                  Refund Policy
                </Link>
                .
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3972" data-mp="ltjoeer9j60w">
                Limitation of Liability
              </h2>
              <p data-id="element-3973" data-mp="1dk7snzo8gris">
                To the fullest extent permitted by law, the International
                Islamic Learning Hub shall not be liable for any indirect,
                incidental, special, consequential, or punitive damages arising
                out of or related to your use of this website or participation
                in our programs.
              </p>

              <h2 className="font-display text-2xl md:text-3xl text-ink-900 mt-12" data-id="element-3974" data-mp="zn2knu4ylikw">
                Governing Law
              </h2>
              <p data-id="element-3975" data-mp="3kanz3z6z2ni2">
                These Terms shall be governed by and construed in accordance
                with the laws applicable to the jurisdiction of the
                organization's legal registration.
              </p>
            </div>
          </div>
        </Container>
      </section>
    </>;
}